<template>
  <div :class="[ismobile ? 'ismobile' : 'logo']">
    <img :src="logo" alt="logo" />
  </div>
</template>

<script>
import common from "@/commom.js";
import logo from "@/assets/img/logo.jpg";
export default {
  name: "Logo",
  data() {
    return {
      ismobile: this.$isMobile,
      logo,
      common,
    };
  },
};
</script>

<style lang="less" scoped>
.logo {
  display: flex;
  background-color: @bgColor;
  padding: 10px 0;
  padding-left: 200px;
}
.ismobile {
  display: flex;
  background-color: @bgColor;
  padding: 10px 0;
  padding-left: 20px;
}
</style>
